import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

/**
 * Single dark variant — luxe nocturne, doré uniquement.
 */
const EditorialAccordion = ({
    index,
    eyebrow,
    title,
    subtitle,
    thumbnail,
    thumbnailPosition = "center",
    children,
    defaultOpen = false,
    testid,
}) => {
    const [open, setOpen] = useState(defaultOpen);

    return (
        <article className="editorial-card group" data-testid={testid} data-open={open}>
            <button
                type="button"
                onClick={() => setOpen((v) => !v)}
                className="w-full text-left flex items-stretch gap-4 md:gap-7 p-4 md:p-7"
                data-testid={`${testid}-toggle`}
                aria-expanded={open}
            >
                <div className="relative shrink-0 w-20 h-20 md:w-28 md:h-28 rounded-2xl overflow-hidden">
                    {thumbnail ? (
                        <img
                            src={thumbnail}
                            alt={title}
                            className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
                            style={{ objectPosition: thumbnailPosition }}
                            loading="lazy"
                        />
                    ) : (
                        <div className="w-full h-full bg-gradient-to-br from-bronze-deep to-ink-700" />
                    )}
                    <div className="absolute inset-0 bg-gradient-to-t from-ink-900/70 to-transparent" />
                    <div className="absolute inset-0 ring-1 ring-inset ring-champagne/20 rounded-2xl" />
                </div>

                <div className="flex-1 min-w-0 flex flex-col justify-center">
                    <div className="flex items-center gap-3 mb-1.5">
                        <span className="text-[10px] md:text-[11px] font-mono-tracked text-champagne/85">
                            {String(index).padStart(2, "0")} · {eyebrow}
                        </span>
                    </div>
                    <h3 className="font-display text-xl sm:text-2xl md:text-3xl text-ivory leading-tight font-light">
                        {title}
                    </h3>
                    {subtitle && (
                        <p className="mt-1.5 text-[13px] sm:text-sm md:text-base text-ivory/65 line-clamp-2 leading-snug">
                            {subtitle}
                        </p>
                    )}
                </div>

                <div className="shrink-0 self-center">
                    <div
                        data-open={open}
                        className="accordion-bubble"
                        aria-hidden
                    >
                        <ChevronDown className="w-5 h-5" />
                    </div>
                </div>
            </button>

            <div
                className={`grid transition-all duration-[700ms] ease-[cubic-bezier(0.22,1,0.36,1)] ${
                    open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                }`}
            >
                <div className="overflow-hidden">
                    <div className="px-5 md:px-7 pb-7 pt-1">
                        <div className="hairline mb-6 opacity-60" />
                        {children}
                    </div>
                </div>
            </div>
        </article>
    );
};

export default EditorialAccordion;
